import type { FaireProductEntity } from "../../entity_types/product";

export const p_4apt7s62ad: FaireProductEntity = {
  token: "p_4apt7s62ad",
  type: "product",
  name: "Gold Plated CZ Micro Pave Safety Pin Clasp Chain LinkCPG1400",
  brandToken: "b_gcccr7fgc5",
  brandName: "Jewel Pledge",
  imageUrl:
    "https://cdn.faire.com/fastly/f0ec03fc1a1bc112bacf329d3ebf4d9c5ca21ddc7ec9ff8abbaf8fa7a07158cf.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fc1b4f80b1ee9b2a93971ce6208f4bdd12fc58651da268c9c28a007de6727f0b.jpeg",
    "https://cdn.faire.com/fastly/2cecd963b7c199d9de0a66940d427db44eb0ef5d74a66f582dc7f735f24201f7.jpeg",
  ],
  priceDollars: 3.44,
  description:
    "18k Gold Safety Pin Clasp Gold Plated CZ Micro Pave Chain Link Connector for Necklace Charm Holder, CPG1400\nMaterials: 18k Gold Plated over Brass\nMeasurements: 8.5mmx 25.9mm\nLead, Nickel, and Cadmium Free\nListing is for one piece only\nShips from Los Angeles",
  tags: [],
  msrpDollars: 6.89,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T22:11:59.644Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
